import getHeaders from "../utils/getHeaders";
import handleTokenExpired from "../utils/handleTokenExpired";

export default async function bookDemoFnJP(
  fields: Record<string, string>,
  accessKey: string | null,
  jwtToken: string | null,
) {
  if (!accessKey) throw new Error("No accessKey in the store");
  if (!jwtToken) throw new Error("No jwtToken in the store");

  const body = Object.fromEntries(
    Object.entries(fields).filter(([, value]) => Boolean(value)),
  );

  const response = await fetch(`${process.env.REACT_APP_API_URL}/book-demo`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...getHeaders({ accessKey, jwtToken }),
    },
    body: JSON.stringify(body),
  });

  if (response.status === 401) {
    handleTokenExpired();
    throw new Error("Unauthorized - token expired");
  }

  const data = await response.json().catch(() => ({}));

  if (!response.ok || data.success !== true)
    throw new Error(data.error || "Network response was not ok");

  return data;
}
